import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/programs/$programId")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
